import { useEffect, useState } from "react";
import { ActionBar } from "../components/ActionBar";
import { FlightTable } from "../components/FlightTable";
import { SetMarkupModal } from "../components/SetMarkupModal";
import {
  cancelFlight,
  getFlightMarkups,
  getMarkupsOptions,
  publishFlight,
} from "../api/markups";
import type {
  DictionariesResponse,
  FlightMarkupItem,
  FlightMarkupListResponse,
} from "../types";
import { FlightsFilters } from "../components/FilterBar";
import { toast } from "sonner";
import {
  getAirports,
  getFilters,
  type Airport,
  type SystemDictionary,
} from "@/shared/api/filters";

export interface FlightsFiltersState {
  airline: string;
  page: number;
  pageSize: number;
  dateFrom: string;
  dateTo: string;
  fromIata: string;
  toIata: string;
  isManual: string;
}

interface FlightsDictionary {
  airlines: { code: string; label: string }[];
  statuses: { code: string; label: string }[];
  flightTypes: { code: string; label: string }[];
}

export function MarkupsPage() {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [isMarkupModalOpen, setIsMarkupModalOpen] = useState(false);
  const [flightsMarkups, setFlightsMarkups] =
    useState<FlightMarkupListResponse>();
  const [markupsOptions, setMarkupsOptions] = useState<FlightsDictionary>();
  const [dictionary, setDictionary] = useState<SystemDictionary | undefined>();
  const [airports, setAirports] = useState<Airport[]>([]);
  const [filters, setFilters] = useState<FlightsFiltersState>({
    airline: "",
    page: 1,
    pageSize: 20,
    dateFrom: "",
    dateTo: "",
    toIata: "",
    fromIata: "",
    isManual: "",
  });
  const [selectedFlight, setSelectedFlight] = useState<FlightMarkupItem | null>(
    null
  );
  const fetchOrders = async () => {
    try {
      const flightsMarkups = await getFlightMarkups(filters);
      const dict = await getFilters();
      const airports = await getAirports();
      setAirports(airports);
      setDictionary(dict);
      setFlightsMarkups(flightsMarkups);
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : "Не удалось добавить пользователя";
      toast.error(message);
      console.error(error);
    }
  };

  const handleToggleFlight = async (status: string, id: string) => {
    try {
      status === "active" ? await cancelFlight(+id) : await publishFlight(+id);
      await fetchOrders();
    } catch (e) {
      toast.error(
        status === "active"
          ? "Не удалось отменить рейс"
          : "Не удалось опубликовать рейс"
      );
      console.error(e);
    }
  };
  useEffect(() => {
    fetchOrders();
  }, [filters, isMarkupModalOpen]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-6">Наценки на рейсы</h1>

      <FlightsFilters
        totalCount={0}
        filteredCount={0}
        dictionary={dictionary}
        setFilters={setFilters}
        filters={filters}
        airports={airports}
      />

      <ActionBar
        className="mt-4"
        selectedCount={selectedIds.length}
        totalCount={flightsMarkups?.total ?? 0}
        displayedCount={flightsMarkups?.data.length ?? 0}
        onSetMarkup={() => setIsMarkupModalOpen(true)}
        onResetSelection={() => setSelectedIds([])}
      />

      <FlightTable
        flights={flightsMarkups?.data ?? []}
        selectedIds={selectedIds}
        onSelectionChange={setSelectedIds}
        page={filters.page}
        pageSize={filters.pageSize}
        total={flightsMarkups?.total ?? 0}
        onPageChange={(page) => setFilters((prev) => ({ ...prev, page }))}
        onSingleFlightSelect={(flight) => {
          setSelectedFlight(flight);
          // теперь есть flight.basePrice и flight.total
        }}
        handleToggleFlight={handleToggleFlight}
      />

      <SetMarkupModal
        open={isMarkupModalOpen}
        onOpenChange={setIsMarkupModalOpen}
        selectedCount={selectedIds.length}
        selectedIds={selectedIds}
        singleFlightPrices={
          selectedFlight
            ? {
                basePrice: selectedFlight.basePrice,
                total: selectedFlight.total,
              }
            : null
        }
      />
    </div>
  );
}
